import React, { useState } from 'react'
import { LuRefreshCcw } from 'react-icons/lu'

import ActionButton from '@/components/misc/ActionButton'
import { cn } from '@/lib/utils'

const ReloadButton: React.FC = () => {
  const [isReloading, setIsReloading] = useState(false)

  return (
    <ActionButton
      isProcessing={isReloading}
      isProcessingText=""
      variant="ghost"
      className={cn(
        'absolute top-0 right-0 -m-1 rounded-full',
        !isReloading && 'transition-transform duration-600 hover:rotate-360',
      )}
      title="Reload page"
      onClick={() => {
        setIsReloading(true)
        window.location.reload()
      }}
      size="icon-lg"
    >
      <LuRefreshCcw />
    </ActionButton>
  )
}

export default ReloadButton
